export default __webpack_public_path__ + "11f4ff2.png";